import ClearingAPI from '@shared/api';

export const {
    achRelationships: { get: getAchRelationships },
} = ClearingAPI.settings;
